<template>
  <div
    :class="[
      'lad-itinerary-section--times',
      showLocations ? 'with-locations' : '',
    ]"
  >
    <el-timeline>
      <el-timeline-item
        v-for="time in visibleTimes"
        :key="time.id"
        :timestamp="time.time"
        placement="top"
      >
        <template v-if="showLocations && time.location" slot="dot">
          <el-tooltip>
            <template slot="content">
              <span>{{ $t(`${base}.show_location_in_map`) }}</span>
            </template>
            <el-button
              icon="el-icon-location-outline"
              plain
              circle
              @click="handleClick(time.location)"
            ></el-button>
          </el-tooltip>
        </template>

        <h3>{{ time.title }}</h3>

        <div
          :class="[
            'lad-itinerary-section--times-description',
            collapsed ? 'hide-summary' : '',
          ]"
          v-html="time.description"
        ></div>
      </el-timeline-item>
    </el-timeline>

    <div v-if="daysNumber > 1" class="lad-itinerary-section--times--footer">
      <el-button type="text" @click="toggleCollapse">
        <i :class="icon" />
        <span>{{ message }}</span>
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LadItineraryTimes',
  props: {
    times: { type: Array, required: true },
    showLocations: { type: Boolean, default: false },
    index: { type: Number, required: true, default: 0 },
    daysNumber: { type: Number, required: true, default: 0 },
  },
  data() {
    return {
      base: 'components.itinerary.section',
      collapsed: this.daysNumber > 1,
      limit: 1,
    }
  },
  computed: {
    visibleTimes() {
      if (this.daysNumber > 1) return this.times.slice(0, this.limit)
      return this.times
    },
    message() {
      return this.collapsed
        ? this.$t('general.show_more')
        : this.$t('general.show_less')
    },
    icon() {
      return this.collapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-left'
    },
  },
  beforeMount() {
    if (this.index === 0 && this.$route.params.test === 'ppcv1') {
      this.toggleCollapse()
    }
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed

      if (this.limit !== this.times.length) {
        this.limit = this.times.length
      } else {
        this.limit = 1
      }

      this.$emit('collapsed', !this.collapsed)
    },
    handleClick(location) {
      this.collapsed = false

      if (this.limit !== this.times.length) {
        this.limit = this.times.length
      }

      this.$emit('collapsed', !this.collapsed)
      this.$emit('location', location)
    },
  },
}
</script>

<style lang="scss">
.lad-itinerary-section--times {
  &-description {
    font-size: 13px;
  }

  &--footer {
    padding: 0 20px 10px;
    text-align: right;
  }

  // https://codepen.io/martinwolf/pen/qlFdp
  .hide-summary {
    display: block;
    max-height: 75px;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: all 0.25s ease-in;
  }

  .el-timeline {
    padding: 20px;

    .el-timeline-item {
      .el-timeline-item__timestamp {
        font-size: 14px;
        color: #808288;
        margin-top: 0;
      }

      .el-timeline-item__tail {
        display: block;
        top: 12px;
      }

      &:last-child .el-timeline-item__tail {
        display: none;
      }
    }
  }

  &.with-locations {
    .el-timeline {
      .el-timeline-item__node {
        left: 12px;
      }

      .el-timeline-item__tail {
        left: 17px;
      }

      .el-timeline-item__wrapper {
        margin-left: 50px;
        padding-left: 0;
      }
    }
  }
}

/** @todo esto afecta de forma global ...revisar si es necesario */
.el-timeline-item__timestamp.is-bottom {
  display: none;
}
</style>
